import { subscribe } from 'shared/store'
import { CREATE_SLIDER } from 'shared/store/ducks/events'
import mountSellerModalContainer from 'views/containers/browser/SellerModalContainer/mountSellerModalContainer'

export default () => {
  subscribe.after(CREATE_SLIDER, () => {
    mountSellerModalContainer()
  })
}
